function PageNotFound() {
  return (
    <h3 className="flex justify-center text-xl font-bold mb-2">
      Page Not Found
    </h3>
  );
}

export default PageNotFound;
